export default {"src":"/_next/static/media/visible.f1dcef75.svg","height":512,"width":512};